<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ $t("lang.inbound.container_detail.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.inbound.container_detail.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box
          dark
          color="outline"
          :title="$t('lang.inbound.container_detail.box_title_1')"
          class="col-12 col-md-6 col-lg-6 col-xl-auto p-1"
        >
          <template slot="actions">
            <bx-order-status :status="status" dark></bx-order-status>
          </template>
          <div class="detail-titles">
            <div class="wrapper">
              <h4>
                Nº <strong>{{ id }}</strong>
              </h4>
              <h5>
                <strong>{{ name }}</strong>
              </h5>
            </div>
          </div>
        </bx-box>

        <bx-box
          dark
          color="outline"
          class="col-12  col-md-6  col-lg-6 col-xl-auto p-1"
        >
          <bx-value
            :label="$t('lang.inbound.container_detail.box_label_2')"
            :value="receptionTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box
          dark
          color="red"
          class="col-6 col-xl-auto p-1 bx-box-adjustable"
        >
          <bx-value
            :label="$t('lang.inbound.container_detail.box_label_3')"
            :value="waitingTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box
          dark
          color="outline"
          class="col-6 col-xl-auto p-1 bx-box-adjustable2"
        >
          <bx-value
            :label="$t('lang.inbound.container_detail.box_label_4')"
            :value="itemCount"
            font-size="sm"
          />
        </bx-box>
      </div>
      <div class="boxes" v-else>
        <div class="col-12 col-md-6 col-lg-3 p-1">
          <PuSkeleton height="10px"></PuSkeleton>
          <PuSkeleton height="90px" class="m-t-5"></PuSkeleton>
        </div>
        <div class="col-12 col-md-6 col-lg-2 p-1">
          <div style="height: 20px"></div>
          <PuSkeleton height="90px" class="m-t-5"></PuSkeleton>
        </div>
        <div class="col-6 col-lg-1 p-1">
          <div style="height: 20px"></div>
          <PuSkeleton height="90px" class="m-t-5"></PuSkeleton>
        </div>
        <div class="col-6 col-lg-1 p-1">
          <div style="height: 20px"></div>
          <PuSkeleton height="90px" class="m-t-5"></PuSkeleton>
        </div>
      </div>
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div
              class="row p-1 mx-1"
              style="background: white"
              v-if="shouldLoading"
            >
              <PuSkeleton height="100px" class="col-12"></PuSkeleton>
              <PuSkeleton
                height="250px"
                class="col-12"
                style="margin-top: 10px"
              ></PuSkeleton>
            </div>
            <bx-box
              :title="$t('lang.inbound.container_detail.table_title')"
              color="white"
              no-padding
              v-if="!shouldLoading"
            >
              <template v-slot:default>
                <div class="bx-heading">
                  <!--<bx-btn>
                Desde <strong>14/02/2019</strong> hasta <strong>15/06/2019</strong>
              </bx-btn>-->
                  <span class="spacer" />
                  <bx-value
                    font-size="md"
                    :value="itemCount"
                    :icon="require('@/assets/i/ordersTimeBig.png')"
                  >
                  </bx-value>
                </div>
                <bx-table
                  :data="data"
                  :columns="columns"
                  paginated
                  backendPagination
                  :currentPage="page"
                  :perPage="itemsPerPage"
                  :total="itemCount"
                  @update:currentPage="updatePage"
                >
                  <template slot-scope="props">
                    <bx-table-column>
                      <router-link
                        :to="
                          `/inbound/order/${id}/gtin/${props.row.itemType}/detail`
                        "
                        class="bx-link bx-link-bold"
                        >{{ props.row.gtin }}</router-link
                      >
                    </bx-table-column>
                    <bx-table-column>
                      {{ props.row.quantity }}
                    </bx-table-column>
                    <bx-table-column>
                      {{ props.row.quantity_real }}
                    </bx-table-column>
                    <bx-table-column>
                      {{ props.row.section }}
                    </bx-table-column>
                    <bx-table-column>
                      {{ props.row.color }}
                    </bx-table-column>
                    <bx-table-column>
                      {{ props.row.cloth_type }}
                    </bx-table-column>
                    <bx-table-column>
                      {{ props.row.model }}
                    </bx-table-column>
                    <bx-table-column>
                      {{ props.row.size }}
                    </bx-table-column>
                    <bx-table-column>
                      <bx-complementary-mini
                        :percent="props.row.ratingPercent"
                      ></bx-complementary-mini>
                    </bx-table-column>
                  </template>
                </bx-table>
              </template>
            </bx-box>
          </div>
        </div>
        <v-row class="d-flex d-sm-none">
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="20"
            style="width: 100%"
          >
            <v-list width="100%">
              <v-list-item
                two-line
                v-for="(item, index) in dataList"
                :key="index"
                class="green lighten-5 ma-2 rounded-lg"
                ripple
                :to="`/inbound/order/${id}/gtin/${item.itemType}/detail`"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <div>
                      {{ item.gtin }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.section
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">{{
                    item.cloth_type
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.quantity_real + "/" + item.quantity }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.color }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.model }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import BxTable from "../../bx-components/BxTable";
import BxTableColumn from "../../bx-components/BxTableColumn";
import BxOrderStatus from "../../bx-components/BxOrderStatus";
import common from "@/utils/common";

export default {
  name: "inbound-order-detail",
  components: { BxOrderStatus, BxTableColumn, BxTable },
  mixins: [common],
  props: {
    id: {
      type: [Number, String]
    }
  },
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      dataList: [],
      orderData: {},
      receptionTime: "",
      waitingTime: "",
      itemCount: "",
      name: "",
      status: 0,
      contents: [],
      reloadInterval: null,
      API_BASE: process.env.VUE_APP_API_BASE,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1
    };
  },
  methods: {
    loadMore() {
      if (
        !this.shouldLoading &&
        this.dataList.length &&
        this.dataList.length < this.itemCount &&
        this.isMobile
      ) {
        this.page++;
        this.getData();
      }
    },
    updatePage(p) {
      this.page = p;
      this.getData(this.locationId);
    },
    async getData() {
      this.orderData = await this.$api.containers.get(this.id);
      this.receptionTime = this.orderData.arrival_date;
      this.status = this.orderData.destination_status;
      this.waitingTime = this.orderData.waiting_time;
      this.name = this.orderData.order_name;

      this.report = await this.$api.containers.report(this.id, {
        offset: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage
      });

      this.itemCount = this.report.count;
      this.data = this.report.results.map((item, key) => {
        return {
          gtin: item.gtin,
          itemType: item.item_type,
          quantity: item.theorical_quantity,
          quantity_real: item.real_quantity !== null ? item.real_quantity : 0,
          cloth_type: item.cloth_type,
          id: item.id,
          size: item.size,
          color: item.colour,
          model: item.model,
          section: item.section,
          ratingPercent:
            ((item.real_quantity - Math.abs(item.difference)) /
              item.theorical_quantity) *
            100
        };
      });

      if (this.isMobile) {
        this.dataList = this.dataList.concat(this.data);
      }

      this.columns = [
        {
          field: "gtin",
          label: this.$t("lang.inbound.container_detail.table_field_1")
        },
        {
          field: "quantity",
          label: this.$t("lang.inbound.container_detail.table_field_2")
        },
        {
          field: "real_quantity",
          label: this.$t("lang.inbound.container_detail.table_field_3")
        },
        {
          field: "section",
          label: this.$t("lang.inbound.container_detail.table_field_4")
        },
        {
          field: "color",
          label: this.$t("lang.inbound.container_detail.table_field_5")
        },
        {
          field: "itemtype",
          label: this.$t("lang.inbound.container_detail.table_field_6")
        },
        {
          field: "model",
          label: this.$t("lang.inbound.container_detail.table_field_7")
        },
        {
          field: "size",
          label: this.$t("lang.inbound.container_detail.table_field_8")
        },
        {
          field: "ratingPercent",
          label: this.$t("lang.inbound.container_detail.table_field_9"),
          width: 200
        }
      ];
      this.shouldLoading = false;
    },
    findByGTIN(myArray, gtin) {
      let res = null;
      myArray.forEach(item => {
        if (item.gtin === gtin) {
          res = item;
        }
      });
      return res;
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.reloadInterval = setInterval(
        this.getData,
        process.env.VUE_APP_RELOAD_TIME
      );
    }
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 89px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 10px;
  }
}
</style>

<style scoped>
@media screen and (max-width: 567px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 89px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 10px;
  }
}
@media screen and (max-width: 411px) {
  .bx-box-adjustable2 >>> .bx-box-content {
    min-height: 89px;
  }

  .bx-box-adjustable2 >>> .bx-value-value {
    margin-top: 10px;
  }
}
</style>
